<template>
	<v-container grid-list-md text-xs-center>
		<v-form v-model="isEditValid">
			<v-layout row wrap>
				<v-flex lg6>
					<label class="blackLabel">* Privilege Key:</label>			
					<v-text-field label="Key" disabled v-model="objPrivEdit.priv_key" :rules="keyRules" required solo single-line></v-text-field>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">* Privilege Description:</label>			
					<v-text-field label="Description" v-model="objPrivEdit.description" :rules="descriptionRules" required solo single-line></v-text-field>
				</v-flex>	
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isEditValid" @click.stop="fncEditPriv()">Edit</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>	
				</div>				
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
			return {				
				privKey: '',
				privDescription: '',
				isEditValid: false,
				keyRules: [
					v => !!v || 'Privilege key is required',				
				],
				descriptionRules: [
					v => !!v || 'Privilege description is required',				
				]				
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncEditPriv() {				
				this.$store.dispatch({
					type: 'fncEditPriv',					
					editPriv: this.objPrivEdit					
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd',
				'objPrivEdit',
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>